export default "__VITE_ASSET__uE_03Uqp__"